// The logo's print inks as sRGB hex for SVG and three.js; app.css mirrors them as --color-logo-red / --color-logo-cyan.
export const LOGO_TEAL = '#4ee1e5';
export const LOGO_RED = '#ff0b0b';
export const LOGO_MAROON = '#8c1919';

export const LOGO_VIEWBOX = { width: 2826.13, height: 3240.52 } as const;

export type LogoFamily = 'teal' | 'red' | 'maroon';

export interface Point {
  x: number;
  y: number;
}

export interface LogoShapeMeta {
  family: LogoFamily;
  buildOrder: number;
  area: number;
  anchor: Point;
  centroid: Point;
}

export const LOGO_SHAPE_META: readonly LogoShapeMeta[] = [
  { family: 'red', buildOrder: 7, area: 194776, anchor: { x: 655, y: 1377 }, centroid: { x: 636, y: 1074 } },
  { family: 'teal', buildOrder: 3, area: 36000, anchor: { x: 720, y: 1668 }, centroid: { x: 723, y: 1516 } },
  { family: 'teal', buildOrder: 4, area: 44486, anchor: { x: 1046, y: 1199 }, centroid: { x: 1189, y: 792 } },
  { family: 'teal', buildOrder: 5, area: 16761, anchor: { x: 1813, y: 300 }, centroid: { x: 1813, y: 298 } },
  { family: 'teal', buildOrder: 6, area: 900000, anchor: { x: 1563, y: 2500 }, centroid: { x: 1955, y: 1746 } },
  { family: 'maroon', buildOrder: 1, area: 780000, anchor: { x: 655, y: 2400 }, centroid: { x: 736, y: 2093 } },
  { family: 'maroon', buildOrder: 2, area: 28000, anchor: { x: 1465, y: 1000 }, centroid: { x: 1465, y: 1018 } },
  { family: 'red', buildOrder: 8, area: 95000, anchor: { x: 1350, y: 400 }, centroid: { x: 1465, y: 470 } },
  { family: 'red', buildOrder: 9, area: 83689, anchor: { x: 1630, y: 2052 }, centroid: { x: 1823, y: 1706 } },
  { family: 'red', buildOrder: 10, area: 80044, anchor: { x: 1831, y: 1976 }, centroid: { x: 2007, y: 1633 } },
] as const;

export const LOGO_CENTROID = { x: 1413, y: 1620 } as const;

export const LOGO_FAMILY_FILL: Record<LogoFamily, string> = {
  teal: LOGO_TEAL,
  red: LOGO_RED,
  maroon: LOGO_MAROON,
};
